module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('i', [_vm._v("A big thank you to all those who contributed")]), _vm._v(" stories to this collection, especially Kathy Cordova, for roping in all her writer friends and helping spread the word. Our friendship is new, but precious nonetheless.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A bow of appreciation to my dear friend Mary Beth Sammons for writerly support over the years and permission to excerpt from her wonderful book "), _c('i', [_vm._v("Gifts with Heart")]), _vm._v(", copyright © 2002 by Mary Beth Sammons. Reprinted by permission of Conari Press.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Mega-thanks to my editor, Jan Johnson, who had the idea for this book in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Thanks to Annette Madden for typing assistance and friendship inspiration.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-203edc29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_acknowledgments.vue
// module id = 72
// module chunks = 0